/**
 * Pagina classifiche di tiro. Solo guardia + Layout: i dati li carica
 * `ShootingLeaderboardsTab`, secondo il pattern page-wrapper del repo.
 */
import { Layout } from "../components/Layout";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { ShootingLeaderboardsTab } from "../components/ShootingLeaderboardsTab";
import { DOMAIN_SHOOTING, hasDomain } from "../lib/domainAccess";

export default function ShootingLeaderboards() {
	const { user, loading } = useAuth();

	if (loading) return null;
	if (!user) return <Navigate to="/login" replace />;
	// L'ambito nasconde la voce di menu; qui si protegge anche il percorso
	// diretto, senza però rompere un link condiviso: si torna alla dashboard.
	if (!hasDomain(user, DOMAIN_SHOOTING))
		return <Navigate to="/dashboard" replace />;

	return (
		<Layout>
			<div className="max-w-2xl mx-auto px-4 py-5 pb-28">
				<h1 className="font-heading text-2xl mb-4">Classifiche tiro</h1>
				<ShootingLeaderboardsTab />
			</div>
		</Layout>
	);
}
